import * as Yup from 'yup';
import PhoneNumber from 'awesome-phonenumber';
import { FormFields } from './types';

export const thirdPartyValidationSchema = Yup.object({
    [FormFields.CUSTOMER_ID]: Yup.string().nullable().required('Customer is required.'),
    [FormFields.JOB_REFERENCE_ID]: Yup.string().nullable().required('Job Reference ID is required.'),
    [FormFields.CUSTOMS_BROKER_EMAIL]: Yup.string().nullable().email('Invalid email address.'),
    [FormFields.CUSTOMS_BROKER_PHONE_CODE]: Yup.string()
        .nullable()
        .test('phoneCode-required', 'Phone country code is required', function (value) {
            const { customsBrokerPhoneNumber } = this.parent as { customsBrokerPhoneNumber?: string | null };
            if (customsBrokerPhoneNumber) return !!value;
            return true;
        }),
    [FormFields.CUSTOMS_BROKER_PHONE_NUMBER]: Yup.string()
        .nullable()
        .test('phoneNumber-valid', 'Phone number is invalid', function (value) {
            const { customsBrokerPhoneCountryCode } = this.parent as { customsBrokerPhoneCountryCode?: string | null };
            if (!customsBrokerPhoneCountryCode && !value) return true;
            if (!customsBrokerPhoneCountryCode) return true;
            if (!value)
                return this.createError({ message: 'Phone number is required when a country code is selected.' });
            const phone = new PhoneNumber(`${customsBrokerPhoneCountryCode}${value}`);
            if (!phone.isValid()) return this.createError({ message: 'Phone number is invalid' });
            return true;
        }),
    [FormFields.MRNS]: Yup.array().of(Yup.string().length(18, 'MRN must be at exactly 18 characters long.')),
});
